const POS_DEVICE_ID_KEY = 'pos_sync_device_id'

function generateDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `pos-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

/** Stable per-installation id for POS sync heartbeats (multi-terminal close gate). */
export function getOrCreatePosDeviceId(): string {
  if (typeof localStorage === 'undefined') {
    return generateDeviceId()
  }
  let id = localStorage.getItem(POS_DEVICE_ID_KEY)
  if (!id) {
    id = generateDeviceId()
    localStorage.setItem(POS_DEVICE_ID_KEY, id)
  }
  return id
}

export function getPosDeviceName(): string {
  if (typeof localStorage === 'undefined') return 'POS'
  return localStorage.getItem('pos_device_name') || 'POS Terminal'
}
